import { AxiosResponse } from 'axios';
import api from '~/services/api';

class SponsoredService {
  getAllSponsored(): Promise<AxiosResponse<any | null>> {
    return api.get<any[]>('/sponsoredProduct/', {
      headers: { dashboard: true }
    });
  }

  getAvailableOrderSponsored({ priceTableCode, subsidiaryExternalCode }): Promise<AxiosResponse<any | null>> {
    return api.get<any[]>('/sponsoredProduct/available', {
      headers: { dashboard: true },
      params: {
        priceTableCode,
        subsidiaryExternalCode
      }
    });
  }

  getSponsored(id: string): Promise<AxiosResponse<any | null>> {
    return api.get<any>(`/sponsoredProduct/${id}`, {
      headers: { dashboard: true }
    });
  }

  createSponsored(notify: boolean, product: any): Promise<AxiosResponse<any | null>> {
    return api.post<any>('/sponsoredProduct', product, {
      params: {
        notify
      }
    });
  }
  editSponsored(notify: boolean, product: any): Promise<AxiosResponse<any | null>> {
    return api.put<any>('/sponsoredProduct', product, {
      params: {
        notify
      }
    });
  }
  deleteSponsored(productID: any): Promise<AxiosResponse<any | null>> {
    return api.delete<null>(`/sponsoredProduct/${productID}`);
  }
}

export default new SponsoredService();
